<template>
  <RevTooltip v-if="shouldDisplay" position="bottom">
    <template #trigger="{ show, hide }">
      <RevButtonBase
        class="text-static-brand-mid body-2-bold lg:text-right"
        @focusin="show"
        @focusout="hide"
        @mouseleave="hide"
        @mouseover="show"
      >
        {{ i18n(translations.itemLowStock, { stock: item.quantityMax }) }}
      </RevButtonBase>
    </template>

    {{ i18n(translations.tooltip) }}
  </RevTooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevTooltip } from '@ds/components/Tooltip'

import translations from './Stock.translations'

const props = defineProps<{
  item: CartItem
}>()

const i18n = useI18n()

const shouldDisplay = computed(() => {
  return (
    props.item.available === 'yes' &&
    props.item.quantityMax > 0 &&
    props.item.quantityMax < 10
  )
})
</script>
